import $ from 'jquery';

var xs = 420;
var sm = 660;
var md = 880;
var lg = 1100;
var xl = 1300;

var init = function () {
  $('.js-toolbox').append('<span class="js-responsive-helper" />');
};

var currentView = function () {
  var viewport;
  var curIndex = $('.js-responsive-helper').css('z-index');

  switch (curIndex) {
    case '0':
      viewport = 'xs';
      break;
    case '1':
      viewport = 'sm';
      break;
    case '2':
      viewport = 'md';
      break;
    case '3':
      viewport = 'lg';
      break;
    case '4':
      viewport = 'xl';
      break;
    default:
      viewport = 'xs';
      break;
  }

  return viewport;
};

export default {
  init,
  xs,
  sm,
  md,
  lg,
  xl,
  currentView,
};
